import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import AggregataSelector from '../../common/AggregataSelector';
import BetsExpandCollapse from '../../common/BetsExpandCollapse';
import ExpandedViewToggle from '../../common/ExpandedViewToggle';
import FastbetToggle from '../../common/fast-bet/FastbetToggle';
import MacrogruppoSelector from '../../common/MacrogruppoSelector';
import { GROUPED_VIEW_MARKETS } from '../../data/constants';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { getConfiguration } from '../../data/utils/configuration';
import { getStatsUrl } from '../../data/utils/getStatsUrl';
import { PrematchContext } from '../Prematch';
import { MatchContext } from './MatchDataFetcher';
import PrematchMatchDropdown from './PrematchMatchDropdown';

function MatchNavbar(props) {
    const conf = getConfiguration();
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const matchContext = React.useContext(MatchContext);
    const [dropdownToggled, setDropdownToggled] = useState(false);

    /*function handleGoBack() {
        prematchContext.openTournament(tournamentUniqueId);
    }*/

    function handleOnClick(e){
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            prematchContext.openTournament(tournamentUniqueId);
        }else{
            if (prematchContext.section === 'match' && window.location.href.endsWith('/prematch')) {
                prematchContext.openMenu();
            } else {
                appContext.setHandleOpenFromPath(true);
            }
        }
    }

    function openStats() {
        prematchContext.toggleStats(statsUrl);
    }

    function toggleDropdown() {
        setDropdownToggled(!dropdownToggled);
    }

    let tournament = null;
    if (prematchContext.tournament && prematchContext.tournament.events && prematchContext.tournament.events.length > 0) {
        tournament = prematchContext.tournament;
    }

    const match = props.match;
    const tournamentUniqueId = [match.sportRef,match.categoryRef,match.tournamentRef].join("_");
    const statsUrl = getStatsUrl(match.id);
    const tournamentPath = [props.match.tournamentUrlPath, props.match.tournamentUrlPathSuffix].join('');
    const relativeTournamentPath = useAbsolutePath(tournamentPath, null, props.match.tournamentUrlPathSeo, true);  
    const noFollow = isSeoSettingsNoFollow(props.match.tournamentUrlPathSeoSettings);

    const showFastbetToggle = conf.anbe;
    let groupedView = false;
    if (props.bets.length === 1 && GROUPED_VIEW_MARKETS.includes(props.bets[0].cs)) {
        groupedView = true;
    }

    return (
        <div className="prematch-tournament-navbars">
            <nav id="nav-go-back" className="nav-go-back">
                <Link to={encodeURI(relativeTournamentPath) } onClick={handleOnClick} {...(noFollow ? {rel: 'nofollow'}:{})} >
                    <div className="arrow-container" /* onClick={handleGoBack} */>
                        <div className="arrow arrow-left"></div>
                    </div>
                </Link>
                <div className="live-tv-button hidden" id="live-widget-switcher-button">
                    <div className="live-tv-button-text"></div>
                </div>
                {match && match.id && match.id >= 0 &&
                    <div className="arrow-container" id="stats-button" onClick={openStats}>
                        <i className="fas fa-chart-bar"></i>
                    </div>
                }
                {tournament ?
                    <div className="title-container" id="live-title-container" onClick={toggleDropdown} >
                        <span className="nav-section-title expandable" id="nav-section-title">
                            <div className="d-flex flex-column justify-content-center text-small">
                                <span>{match.team1}</span>
                                {match.team2 &&
                                    <span>{match.team2}</span>
                                }
                            </div>
                        </span>
                    </div>
                    :
                    <div className="title-container">
                        <span className="nav-section-title" id="nav-section-title-match">
                            <div className="d-flex flex-column justify-content-center text-small">
                                <span>{match.team1}</span>
                                {match.team2 &&
                                    <span>{match.team2}</span>
                                }
                            </div>
                        </span>
                    </div>
                }
                <div className="arrow-container" id="refresh-button" onClick={props.reloadData}>
                    <span className="refresh-ico"></span>
                </div>
                <BetsExpandCollapse/>
                {dropdownToggled &&
                    <PrematchMatchDropdown tournament={tournament} toggleDropdown={toggleDropdown} />
                }
            </nav>
            {!prematchContext.showStats &&
                <>
                    {props.macrogruppo ?
                        <>
                            {props.macrogruppi.length > 1 &&
                                <MacrogruppoSelector macrogruppi={props.macrogruppi} macrogruppo={props.macrogruppo.id} changeMacrogruppo={props.changeMacrogruppo} />
                            }
                            {!matchContext.favoritesSelected && props.macrogruppo.aggregate.length > 1 &&
                                <AggregataSelector betGroups={props.macrogruppo.aggregate} aggregata={props.aggregata} changeBetGroup={props.changeAggregata} />
                            }
                        </>
                        :
                        <>
                            {!matchContext.favoritesSelected && props.gruppiScommessa.length > 1 &&
                                <AggregataSelector betGroups={props.gruppiScommessa} aggregata={props.aggregata} changeBetGroup={props.changeAggregata} />
                            }
                        </>
                    }
                </>
            }
            {groupedView &&
                <nav id="nav-vista-estesa" className="small">
                    {showFastbetToggle &&
                        <FastbetToggle />
                    }
                    <ExpandedViewToggle />
                </nav>
            }
        </div>
    );
}

export default MatchNavbar;